import { render, staticRenderFns } from "./EinstellungenNoteneingabe.vue?vue&type=template&id=b9de7c86&"
import script from "./EinstellungenNoteneingabe.vue?vue&type=script&lang=js&"
export * from "./EinstellungenNoteneingabe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports